/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Instagram {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Loader, Section } from "@bw/bits"
import { Instagram as InstagramModule } from "@bw/modules"
import axios from "axios"

const Instagram = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  idAttribute,
  classAttribute,
  backgroundVariant,
  isFollowedByModuleWithBackgroundVariant,
  numberOfMedias,
  numbersOfColumns,
}) => {
  const [response, setResponse] = React.useState({
    loading: true,
    isError: false,
    data: [],
  })

  React.useEffect(() => {
    axios
      .get(`${process.env.GATSBY_API_URL}/api/instagram`)
      .then(response => {
        setResponse({
          loading: false,
          isError: false,
          data: response.data.data,
        })
      })
      .catch(() => {
        setResponse({ loading: false, isError: true })
      })
  }, [])

  if (response.isError) {
    return null
  }

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition,
        idAttribute,
        classAttribute,
        backgroundVariant,
        isFollowedByModuleWithBackgroundVariant,
      }}
    >
      {response.loading ? (
        <Loader />
      ) : (
        <InstagramModule
          posts={response.data.slice(0, numberOfMedias)}
          numbersOfColumns={parseInt(numbersOfColumns.value)}
        />
      )}
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ...InstagramModuleFragment
 *
 * This is also what you will get in the props of your Instagram
 * resolver component.
 */
export const query = graphql`
  fragment InstagramModuleFragment on InstagramModule {
    numberOfMedias
    numbersOfColumns {
      value
    }
  }
`

export { Instagram }
